import { makeCell, makeRowSet } from './gridUtill';

let fields = [];
let columns = [];

// 구분 컬럼
makeCell(1, [{ field: 'category', alias: '구분', indexExclusive: true }], fields, columns);

// 원료 컬럼 (PK로 사용)
makeCell(1, [{ field: 'material', alias: '원료', indexExclusive: true }], fields, columns);

// Mw (g/mol) 컬럼
makeCell(1, [{ field: 'mw', alias: 'Mw (g/mol)', indexExclusive: true }], fields, columns);

// Density (g/cm3) 컬럼
makeCell(1, [{ field: 'density', alias: 'Density (g/cm3)', indexExclusive: true }], fields, columns);

// 비고 컬럼
makeCell(1, [{ field: 'remark', alias: '비고', indexExclusive: true }], fields, columns);

// 등록일 컬럼
makeCell(1, [{ field: 'reg_date', alias: '등록일', indexExclusive: true }], fields, columns);

// 등록자 컬럼
makeCell(1, [{ field: 'reg_user', alias: '등록자', indexExclusive: true }], fields, columns);

const rowSet = makeRowSet(fields);
const errorMessage = '원료 특성 데이터가 없습니다';
const hideCheckBar = true;

export { fields, columns, rowSet, errorMessage, hideCheckBar }; 